"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configureStore = void 0;
/*
 * Copyright 2023, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const redux_1 = require("redux");
const redux_thunk_1 = require("redux-thunk");
const auth_1 = require("chaire-lib-frontend/lib/store/auth");
const survey_1 = require("../store/survey");
const loadingState_1 = require("../store/loadingState");
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || redux_1.compose;
const initialState = {
    auth: { isAuthenticated: false },
    survey: {},
    loadingState: { loadingState: 0 }
};
// Create the combined reducer
const appReducer = (0, redux_1.combineReducers)({
    auth: auth_1.authReducer,
    survey: survey_1.surveyReducer,
    loadingState: loadingState_1.loadingStateReducer
});
// Root reducer wrapper that handles clearing state on logout
const rootReducer = (state, action) => {
    // When a logout action is detected, reset the state
    if (action.type === auth_1.AuthActionTypes.LOGOUT) {
        // Pass undefined as state to each reducer to get their initial states
        return appReducer(undefined, action);
    }
    // For all other actions, just use the combined reducer normally
    return appReducer(state, action);
};
// FIXME Use @reduxjs/toolkit instead to configure the store
const configureStore = (preloadedState = initialState) => {
    const store = (0, redux_1.createStore)(rootReducer, preloadedState, composeEnhancers((0, redux_1.applyMiddleware)(redux_thunk_1.thunk)));
    return store;
};
exports.configureStore = configureStore;
//# sourceMappingURL=configureStore.js.map